export default __webpack_public_path__ + "img/2c99fd8c0be6db0d14c55c4bf43299f6.png";